export default "__VITE_ASSET__CTWNMuAW__"